<template>
    <section class="section">
      <div class="container content">
        <div class="columns is-multiline">
          <div class="column is-12 has-text-centered" style="margin-top:20px;margin-bottom:20px;">
            <h1 class="title is-size-2 is-size-3-mobile script primary is-spaced">{{ view.content.headline }}</h1>
            <p class="subtitle is-size-4 is-size-6-mobile" v-if="view.content.subtitle.length">{{ view.content.subtitle }}</p>
          </div>
          <div class="column is-12">

            <span v-html="view.content.text"></span>

          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: ['view'],
  computed: {
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  },
  components: {
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Content.vue